import { Component, OnInit, SkipSelf } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { CopyService } from '../../services/copy.service';
import { RegistrationService } from '../../services/registration.service';
import { HotelService } from '../../services/hotel.service';
import { DateUtilityServiceService } from '../../services/date-utility-service.service';
import moment from 'moment-timezone';
import _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { HotelDetailsComponent } from 'src/app/reusable-components/hotel-details/hotel-details.component';
import { VariablesService } from 'src/app/services/variables.service';
import { PaymentService } from 'src/app/services/payment.service';

@Component({
    templateUrl: './hotel-booking.component.html',
    standalone: false
})
export class HotelBookingComponent implements OnInit {
  enrollment;
  isSubmitting = false;
  hotelList;
  dateRange;
  groupDays;
  preextend;
  postextend;
  hotelStay;
  submitted;
  attendee;
  HoldSpecialRequests;
  isError = false;
  noHotel = false;
  isFormCompleted = false;
  isRegComplete: any;
  hotelneeded={Value:undefined};
  otherNoHotel;
  soldOutHotels = [];

  bedding;
  roommate;
  roommateemail;
  roommatearrive;
  roommatedepart;
  pickedHotel;
  bedTypes = [
    "King",
    "Two Double Beds",
    "No Preference" 
  ]

  constructor(
    private navigationService: NavigationService,
    private copyService: CopyService,
    private registrationService: RegistrationService,
    private hotelService: HotelService,
    private dateService: DateUtilityServiceService,
    public dialog: MatDialog,
    private variablesService: VariablesService,
    private paymentService: PaymentService
  ) {
    this.enrollment = this.registrationService.getEnrollment({});
    this.attendee = this.registrationService.getAttendee({});
    this.hotelStay = this.registrationService.getHotel([]);
    if(this.hotelStay.length > 0){
      this.pickedHotel = this.hotelStay[0].Hotel
    }
    this.isRegComplete = this.registrationService.isRegistrationComplete();

    this.bedding = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.BEDDING.ID,
      {}
    );
    this.roommate = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATE.ID,
      {}
    );
    this.roommateemail = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATEEMAIL.ID,
      {}
    );
    this.roommatearrive = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATEARRIVE.ID,
      {}
    );
    this.roommatedepart = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATEDEPART.ID,
      {}
    );

    this.setRoommateDates();
    
    //prefill hotelneeded and otherNoHotel
    if(this.enrollment.HotelNeeded){
      this.hotelneeded.Value = "Y";
    }else if(this.enrollment.HotelNeeded === false){
      if(this.roommate.Value){
        this.hotelneeded.Value = "R";
      }else{
        this.hotelneeded.Value = "N";
      }
    }


    this.hotelService.getHotelList().then(list => {
      this.hotelList = list;
      if (this.hotelList) {
        this.dateRange = this.dateService.calculateDateRange(this.hotelList.firstNight, this.hotelList.lastNight);
        this.preextend = this.dateService.dateDiff(moment.utc(this.hotelList.firstNight, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"), moment.utc(this.hotelList.groupStartDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"));

        this.groupDays = dateService.dateDiff(moment.utc(this.hotelList.groupStartDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"), moment.utc(this.hotelList.groupEndDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"));
        this.postextend = dateService.dateDiff(moment.utc(this.hotelList.groupEndDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"), moment.utc(this.hotelList.lastNight, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"));

        this.hotelList.roomTypeList.sort((a, b) => {
          return a.supplierName.localeCompare(b.supplierName)})


        if (!this.hotelStay.length) {
          //look for booked stays.
          this.hotelList.roomTypeList.forEach((roomtype) => {
            var groupid = roomtype.webHotelGroupID;
            var pending = _.filter(roomtype.roomNightsListWithRate, { availabilityCode: 2 });
            var reserved = _.filter(roomtype.roomNightsListWithRate, { availabilityCode: 3 });
            reserved = _.union(pending, reserved);
            reserved.forEach((res) => {
              this.hotelStay.push({ Date: res.blockDate, Hotel: groupid });
            });
          });
        }

        if (this.isRegComplete) {
          if (this.enrollment.WebHotelBooking.length) {
            //look for booked stays.
            this.hotelList.roomTypeList.forEach((roomtype) => {
              var groupid = roomtype.webHotelGroupID;
              var pending = _.filter(roomtype.roomNightsListWithRate, { availabilityCode: 2 });
              var reserved = _.filter(roomtype.roomNightsListWithRate, { availabilityCode: 3 });
              reserved = _.union(pending, reserved);
              reserved.forEach((res) => {
                this.hotelStay.push({ Date: res.blockDate, Hotel: groupid });
              });
            });
          }

          let filter = [];
          this.hotelStay.forEach((stay) => {
            if (stay.Date.indexOf("0000000") < 0) {
              filter.push(stay);
            }
          });
          filter = _.uniqBy(filter, 'Date');
          this.hotelStay = filter;
          this.enrollment.WebHotelBooking = filter;
        }
        this.hotelList.roomTypeList.forEach(hotelNight => {
          hotelNight.roomNightsListWithRate.forEach(hotel => {
            if(hotel.availabilityCode === 0) {
              if (!this.outsideGroupDates(hotel.blockDate)){
                this.soldOutHotels.push(hotelNight.webHotelGroupID)
              }
            }
          });
        });



      }
    });
  }
  ngOnInit(): void {
    this.paymentService.emitter.subscribe({
      next: (event) => {
        console.log(event);
        if(this.isFormCompleted){
          this.checkpayment();
        }
      }
    });
  }
  noHotelRadios = [
    { display: "Staying at local residence", value: "Staying at local residence" },
    { display: "Sharing a room reserved by someone else", value: "Sharing a room reserved by someone else" },
    { display: "Arranged my own accommodations", value: "Arranged my own accommodations" },
    { display: "Other", value: "Other" }
  ];
  //this was how steven showed hotels not available if you selected a diff hotel
  //  but they wanted to just disable the check boxes like they did last year
  // isHotelAvailableOnDate(hotellist, date) {
  //   if(this.attendee.PAXTypeNo == 0){
  //     let hotel = this.findDate(hotellist, date);      
  //     if (hotel) {
  //       if (hotel.availabilityCode === 1 || hotel.availabilityCode === 2 || hotel.availabilityCode === 3) {
  //         if(this.hotelStay.length>0){
  //           if(this.hotelStay[0].Hotel === hotellist.webHotelGroupID){
  //             return true;
  //           }else{
  //             return false;
  //           }
  //         }else{
  //           return true;
  //         }
  //       } else {
  //         return false;
  //       }
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     if(this.hotelStay.length>0){
  //       if(this.hotelStay[0].Hotel === hotellist.webHotelGroupID){
  //         return true;
  //       }else{
  //         return false;
  //       }
  //     }else{
  //       return !this.soldOutHotels.includes(hotellist.webHotelGroupID)
  //     }
      
  //   }

  // };
  isHotelAvailableOnDate(hotellist, date) {
    //i have no idea why we have this if paxtype = 0
    if(this.attendee.PAXTypeNo == 0){
      let hotel = this.findDate(hotellist, date);
      if (hotel) {
        if (hotel.availabilityCode === 1 || hotel.availabilityCode === 2 || hotel.availabilityCode === 3) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return !this.soldOutHotels.includes(hotellist.webHotelGroupID)
    }

  };

  unchecked(){
    if(this.hotelStay.length === 0){
      this.pickedHotel = undefined;
    }
  }

  addNight(date, hotel) {
    console.log("add night");
    this.noHotel = false;
    this.pickedHotel = hotel;

    console.log(this.noHotel);
    var tobe = { Date: date, Hotel: hotel };
    var search = _.filter(this.hotelStay, { Date: date });
    if (search.length) {
      _.remove(this.hotelStay, search[0]);
      if (search[0].Hotel !== hotel) {
        this.hotelStay.push(tobe);
      }
    } else {
      this.hotelStay.push(tobe);
    }

    var isExtension = false;
    this.hotelStay.forEach((stay) => {

      var date = this.dateService.createMoment(stay.Date).toDate();

      if (this.outsideGroupDates(date)) {
        isExtension = true;
      }
    });
    if (isExtension) {
      this.enrollment.$mtcExtension = true;
    } else {
      this.enrollment.$mtcExtension = undefined;
    }
  };


  clearRequests() {
    console.log(this.hotelneeded);
    if(this.hotelneeded.Value=="Y"){
      this.enrollment.HotelNeeded = true;
    }else if(this.hotelneeded.Value){
      this.enrollment.HotelNeeded = false;
    }
    console.log(this.enrollment.HotelNeeded);
    if (this.enrollment.HotelNeeded === true) {
      if (this.enrollment.HotelSpecialRequests === "Staying at local residence" || this.enrollment.HotelSpecialRequests === "Sharing a room reserved by someone else"
        || this.enrollment.HotelSpecialRequests === "Arranged my own accommodations" || this.enrollment.HotelSpecialRequests === "I will add my hotel later") {
        this.HoldSpecialRequests = this.enrollment.HotelSpecialRequests;
        this.enrollment.HotelSpecialRequests = "";
      }
    } else if (this.HoldSpecialRequests) {
      this.enrollment.HotelSpecialRequests = this.HoldSpecialRequests;
    }
  }

  outsideGroupDates(date) {
    console.log(date + " < " + this.hotelList.groupStartDate);
    return date < moment.utc(this.hotelList.groupStartDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago").toDate()
      || date > moment.utc(this.hotelList.groupEndDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago").toDate();
  };

  findDate(hotelList, searchDate) {
    let newDate = moment.utc(searchDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").toDate();
    var match;
    if (typeof newDate !== "undefined") {
      match = _.find(hotelList.roomNightsListWithRate, (night) => {
        var blockDate = moment.utc(night.blockDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago").toDate();

        return newDate.getDate() === blockDate.getDate() && newDate.getMonth() === blockDate.getMonth();
      });
    }
    return match;
  };

  getNonContiguousHotels() {
    var hotels = [];
    if (typeof this.hotelList !== "undefined") {
      hotels = this.hotelService.getNonContiguousHotelNights(this.hotelList.roomTypeList, this.hotelStay);
    }
    return hotels;
  };
  isChecked(date, hotel) {
    //console.log("in isChecked");
    var search = _.filter(this.hotelStay, { Date: date });
    if (search.length) {
      if (search[0].Hotel === hotel) {
        //console.log("return true");
        return true;
      }
    }
    return false;
  };
  getColor(night) {
    if (night.availabilityCode === 0) {
      return '#fcb1ae'
    }
    if (night.isBookedAsPending === true) {
      return '#f8fab1';
    }
    if (night.isBookedAsPending === false) {
      return '#bcffb5'
    }
    return 'white';
  }

  payment;
  CCerror;
  
  checkpayment(){
    this.CCerror=undefined;
    if (this.hotelneeded.Value !== 'N'){
      this.payment = this.registrationService.getPayment([]);

      let card = this.registrationService.getCreditCard(this.payment, 'Hotel', undefined);
      if (!card || !card.ReferenceKey && card.MediaType === "CREDITCARD") {
        this.CCerror="Hotel Guarantee Card is required";
      }
    }
  }

  forward(form) {
    console.log("in forward");
    this.isFormCompleted = true;
    this.checkpayment();
    console.log(this.CCerror);
    if (this.enrollment.HotelNeeded !== undefined && form.valid && !this.CCerror) {
      console.log("here 1");
      if (this.enrollment.HotelNeeded) {
        // User must have selected hotels on contiguous dates
        if (this.hotelStay.length > 0 && this.hotelService.getNonContiguousHotelNights(this.hotelList.roomTypeList, this.hotelStay).length <= 0) {
          this.roommatearrive.Value = ""; 
          this.roommatedepart.Value = "";
          this.isSubmitting = true;
          this.navigationService.forward();
        } else {
          this.noHotel = true;
          this.isError = true;
          this.isSubmitting = false;
        }
      } else {
        console.log("here 2");
        if(this.enrollment.HotelSpecialRequests == 'Other'){
          this.enrollment.HotelSpecialRequests = this.otherNoHotel;
        }

        if(this.hotelneeded.Value == "R"){
          this.bedding.Value = "";
          this.roommateemail.Value = "";
        }else if(this.hotelneeded.Value == "N"){
          this.bedding.Value = "";
          this.roommate.Value = "";
          this.roommateemail.Value = "";
          this.roommatearrive.Value = ""; 
          this.roommatedepart.Value = "";
        }
        this.enrollment.WebHotelBooking = [];
        this.isSubmitting = true;
        this.navigationService.forward();
      }
    } else {
      console.log("here 3");
      this.isSubmitting = false;
    }
  }

  back() {
    this.navigationService.back();
  }

  showModal(hotel) {
    // if (!hotel.displaySection) {
        // new ModalService("Hotel" + hotel.webHotelGroupDesc.replace(/[\s]/g, ""), "Hotel Details");
    let dialogRef = this.dialog.open(HotelDetailsComponent, { panelClass: 'hotel-container', data: hotel});
    hotel.displaySection = false;
  }

  arrivalDatesAll = [
    "Friday, September 12, 2025",
    "Saturday, September 13, 2025",
    "Sunday, September 14, 2025", //
    "Monday, September 15, 2025", //
    "Tuesday, September 16, 2025" //
  ];

  departureDatesAll = [
    "Sunday, September 14, 2025",//
    "Monday, September 15, 2025",//
    "Tuesday, September 16, 2025",//
    "Wednesday, September 17, 2025",
    "Thursday, September 18, 2025",
    "Friday, September 19, 2025",
  ];
  arrivalDates = [];

  departureDates = [];
  setRoommateDates(){
    this.arrivalDates = [...this.arrivalDatesAll];
    this.departureDates = [...this.departureDatesAll];

    if(this.roommatearrive.Value == 'Tuesday, September 16, 2025'){
      this.departureDates.shift();
      this.departureDates.shift();
      this.departureDates.shift();
    }
    if(this.roommatearrive.Value == 'Monday, September 15, 2025'){
      this.departureDates.shift();
      this.departureDates.shift();
    }
    if(this.roommatearrive.Value == 'Sunday, September 14, 2025'){
      this.departureDates.shift();
    }

    if(this.roommatedepart.Value == 'Sunday, September 14, 2025'){
      this.arrivalDates.pop();
      this.arrivalDates.pop();
      this.arrivalDates.pop();
    }
    if(this.roommatedepart.Value == 'Monday, September 15, 2025'){
      this.arrivalDates.pop(); 
      this.arrivalDates.pop();
    }
    if(this.roommatedepart.Value == 'Tuesday, September 16, 2025'){
      this.arrivalDates.pop();
    }
   
  }
}
